import { application } from "./application.js"

const controllers = import.meta.webpackContext(".", {
  recursive: true,
  regExp: /_controller\.js$/
})

controllers.keys().forEach((path) => {
  const controller = controllers(path)
  const identifier = path
    .replace("./", "")
    .replace(/_controller\.js$/, "")
    .replace(/\//g, "--")
    .replace(/_/g, "-")

  application.register(identifier, controller.default)
})
